import { Injectable } from '@angular/core';

@Injectable()
export class TableService {

  filter = '';
  filteredValue = [];
  sortField = 'name';
  sortOrder: 1 | -1 = 1;
  page = { first: 0, rows: 10 };
  numRows = 10;

  constructor() { }

  setDefaults() {
    this.filter = '';
    this.sortField = 'name';
    this.sortOrder = 1;
    this.page = { first: 0, rows: 10 };
    this.numRows = 10;
  }

  listen(event, type: 'sort' | 'page' | 'filter') {
    switch (type) {
      case 'sort':
        this.sortField = event.field;
        this.sortOrder = event.order;
        break;

      case 'page':
        this.numRows = event.rows;
        this.page = event;
        break;

      case 'filter':
        this.filteredValue = event.filteredValue;
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/providers/table-service.service.ts